export default __webpack_public_path__ + "static/colad-fb706500304759d0f0bd6ac32eadb084.png";